import { useEffect } from "react"
import useValidation from "../../../../hooks/useValidation"
import identityValidationSchema from "../../../../utils/validation/limited-company-creation/identityValidationSchema"
import { civilities } from "../../../../static/types/limited-company-creation/representativeType"
import { IdentityType } from "../../../../static/types/limited-company-creation/identityType"
import useAppContext from "../../../../hooks/useAppContext"
import { AppContextType } from "../../../../context/AppContext"

type identityProps = {
    checked: boolean,
    identity: IdentityType,
    changeIdentity: ( partialIdentity: Partial<IdentityType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function Identity ({
    checked,
    identity,
    changeIdentity,
    onValidationChange
}: identityProps ) {

     
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    const { errors, isValid } = useValidation( identity, identityValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )
        
        let draft = parseDraft()
        const tempDraft = { ...draft, identity }
        setDraftFormData( stringifyDraft( tempDraft ))
    }, [ isValid, onValidationChange ])

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "civilite" className = "col-sm-2 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-control ${ ( checked && errors.civility ) ? 'is-invalid' : ''}` }
                        name = "civilite"
                        id = "civility"
                        value = { identity.civility }
                        onChange = { event => changeIdentity({ civility: event.target.value as "Monsieur" | "Madame" } )}
                    >
                        {
                            civilities.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {  ( checked && errors.civility ) && <div className="invalid-feedback"> { errors.civility } </div> }

                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "nom" className = "col-sm-2 col-form-label">Nom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.lastName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "nom"
                        id = "lastName"
                        value = { identity.lastName }
                        onChange = { event => changeIdentity({ lastName: event.target.value })}

                    />
                    {  ( checked && errors.lastName ) && <div className="invalid-feedback"> { errors.lastName } </div> }

                </div>

                <label htmlFor = "prenom" className = "col-sm-2 col-form-label">Prénom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <input
                        className = { `form-control ${ ( checked && errors.firstName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "firstName"
                        value = { identity.firstName }
                        onChange = { event => changeIdentity({ firstName: event.target.value })}
                    />
                    {  ( checked && errors.firstName ) && <div className="invalid-feedback"> { errors.firstName } </div> }

                </div>

            </div>

        </div>
    )
}